module.exports = __webpack_public_path__ + "img/home_1.4d3b2675.jpg";